"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MidSendBanner.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _broadcast = require('shared/selectors/broadcast');
var _hooks = require('web/services/hooks');
var _format = require('web/screens/Broadcast/format');

/* Mockup 08, Rev 35 E1: once some messages are out, editing the message
 * still reaches everyone not yet sent, because each message renders at send
 * time. Shown in Edit message's Message mode only. */
const MidSendBanner = ({ campaignKey }) => {
  const stats = _hooks.useAppSelector.call(void 0, state => _broadcast.selectCampaignStats.call(void 0, state, campaignKey))
  const sent = stats.completed
  const remaining = stats.not_scheduled + stats.queued + stats.processing
  if (!sent || !remaining) return null

  return (
    _react2.default.createElement('div', { className: "broadcast-banner broadcast-banner--info campaign-body--mid-send"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
      , _react2.default.createElement('span', { className: "broadcast-banner--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}, "✎")
      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, "Saving changes the message for the "
              , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 21}},  _format.formatCount.call(void 0, remaining) , " not yet sent"   ), ". The" , ' '
        ,  _format.formatCount.call(void 0, sent) , " already sent keep the text they got."
      )
    )
  )
}

exports. default = _react.memo.call(void 0, MidSendBanner)
